var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserNot({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666672 8.50008C0.666672 4.44999 3.94992 1.16675 8 1.16675C12.0501 1.16675 15.3333 4.44999 15.3333 8.50008C15.3333 12.5501 12.0501 15.8334 8 15.8334C3.94992 15.8334 0.666672 12.5501 0.666672 8.50008ZM3.27199 12.1945C2.47504 11.1761 2.00001 9.89355 2.00001 8.50008C2.00001 5.18637 4.6863 2.50008 8.00001 2.50008C11.3137 2.50008 14 5.18637 14 8.50008C14 9.86835 13.542 11.1296 12.771 12.1389C11.6728 10.7355 9.96321 9.83341 8.043 9.83341C6.09752 9.83341 4.36831 10.7593 3.27199 12.1945ZM4.21844 13.1586C5.25043 13.9973 6.56651 14.5001 8 14.5001C9.45873 14.5001 10.7959 13.9795 11.8359 13.114C10.9889 11.9348 9.6056 11.1667 8.043 11.1667C6.4607 11.1667 5.06234 11.9542 4.21844 13.1586ZM8.00001 9.16675C9.47274 9.16675 10.6667 7.97282 10.6667 6.50008C10.6667 5.02732 9.47274 3.83341 8.00001 3.83341C6.52725 3.83341 5.33334 5.02732 5.33334 6.50008C5.33334 7.97282 6.52725 9.16675 8.00001 9.16675ZM8 7.83342C8.7364 7.83342 9.33334 7.23648 9.33334 6.50008C9.33334 5.7637 8.7364 5.16675 8 5.16675C7.26361 5.16675 6.66667 5.7637 6.66667 6.50008C6.66667 7.23648 7.26361 7.83342 8 7.83342Z",
    fill: "#8D8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserNot);
export default __webpack_public_path__ + "static/media/user-not.0da8f24d5ae4393e5aec85971fcff3d9.svg";
export { ForwardRef as ReactComponent };